// React | contentful.js
import React from 'react';
import PropTypes from 'prop-types';
import { createClient } from 'contentful';
import LoadingIndicator from './layout/indicators/loading';

const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_TOKEN,
  host: process.env.REACT_APP_CONTENTFUL_HOST
})

export default class Contentful extends React.Component {
  // set default state for the data to be fetched
  // and possible errors
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      items: [],
      query: this.props.query,
      loading: null,
      loadingIndicator: props.loadingIndicator || null
    }
  }

  componentDidMount() {
    this.setState({ loading: true });

    // make the API call
    client.getEntries({...this.state.query, include: 5})
    .then(({ items, limit, skip, total }) => {
      this.setState({
        items,
        limit,
        skip,
        total,
        loading: false,
      })
    })
    .catch(error => this.setState({
      error,
      loading: false
    }))
  }

  render() {
    const { loadingIndicator, loading } = this.state;

    if (loadingIndicator !== null && loading === true) {
      return <LoadingIndicator/>;
    }

    // return and render the function
    // that was passed in via `children` prop
    return this.props.children({
      items: this.state.items,
      limit: this.state.limit,
      skip: this.state.skip,
      total: this.state.total,
      error: this.state.error
    });
  }
}

Contentful.propTypes = {
  query: PropTypes.object.isRequired,
  loadingIndicator: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/contentful.jsx